<template>
    <b-card :title="title" :body-class="{ 'px-0': isCustomerPortal }">
        <b-card-body class="p-0 mt-2">
            <b-form @submit.stop.prevent="updatePassword">
                <b-row>
                    <b-col md="6" cols="12">
                        <label class="mb-3"><strong>{{ $translate('first_name') }}<span
                                    class="red">*</span></strong></label>
                        <b-form-input id="input-first_name" readonly v-model="model.first_name" type="text"
                            required></b-form-input>
                    </b-col>
                    <b-col md="6" cols="12">
                        <label class="mb-3 mt-md-0 mt-3" label-for="input-last_name"><strong>{{ $translate('last_name')
                        }}<span class="red">*</span></strong></label>
                        <b-form-input id="input-last_name" readonly v-model="model.last_name" type="text"
                            required></b-form-input>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col md="6" cols="12">
                        <label class="mb-3 mt-3" label-for="input-email"><strong>{{ $translate('email') }}<span
                                    class="red">*</span></strong></label>
                        <b-form-input id="input-email" readonly v-model="model.email" type="text" required></b-form-input>
                    </b-col>
                    <b-col md="6" cols="12">
                        <label class="mb-3 mt-3" label-for="input-current-password"><strong>{{ $translate('password')
                        }}<span class="red">*</span></strong></label>
                        <b-form-input id="input-current-password" required v-custom-validation="$textRequired()"
                            type="password" autocomplete="off" v-model="model.current_password">
                        </b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" cols="12">
                        <label class="mb-3 mt-3" label-for="input-new-password"><strong>{{ $translate('new_password')
                        }}<span class="red">*</span></strong></label>
                        <b-form-input required id="input-new-password" type="password" v-custom-validation="$textRequired()"
                            v-model="model.password">
                        </b-form-input>
                        <p class="muted-text">{{ $translate('password_pattern') }}</p>
                    </b-col>
                    <b-col md="6" cols="12">
                        <label class="mb-3 mt-3" label-for="input-confirm-password"><strong>{{ $translate('retype_password')
                        }}<span class="red">*</span></strong></label>
                        <b-form-input type="password" required v-custom-validation="$textRequired()"
                            v-model="model.password_confirmation" id="input-confirm-password"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" cols="12">
                        <label class="mb-3 mt-3" label-for="uploadData"><strong>{{ $translate('profile_pic')
                        }}</strong></label>
                        <link-modal v-model="model.profile" :image="user.profile_image"></link-modal>
                    </b-col>
                    <b-col class="d-flex" md="6" cols="12">
                        <label class="mb-3 mt-3" for="flexSwitchCheckDefault"><strong>{{ $translate('notifications')
                        }}</strong></label>
                        <b-col class="form-check form-switch mt-3 ms-3">
                            <input class="form-check-input m-0" v-model="model.notification" :value="toggleValue"
                                @change="toggleNotification()" type="checkbox" role="switch" id="flexSwitchCheckDefault">
                        </b-col>
                    </b-col>
                </b-row>
                <div class="text-center">
                    <b-button class="my-4" type="submit" variant="info" :disabled="updating ? true : false">{{
                        updating
                        ? $translate('changing_password')
                        : $translate('change_password')
                    }}</b-button>
                    <b-button class="ms-2" v-if="isCustomerPortal && !isFirstimeLogin" variant="info" @click="cancel()">{{
                        $cancelLabel() }}</b-button>
                </div>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
// import { debounce } from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import LinkModal from '@/components/LinkModal'

export default {
    name: 'ManagePassword',
    mixins: [popupMixins],
    data: () => ({
        model: {},
        updating: false,
    }),
    props: ['title', 'customerClass'],
    components: { LinkModal },
    computed: {
        user() {
            return this.$store.state.user
        },
        toggleValue() {
            return this.$store.state.notifications.toggle
        },
        isCustomerPortal() {
            return this.$route.name == 'CustomerProfile'
        },
        isFirstimeLogin() {
            return this.user.is_first_time_login
        },
        successAlert() {
            return {
                title: this.$translate('success'),
                message: this.$translate('profile_pic_uploaded')
            }
        }
    },
    watch: {
        "model.profile": {
            handler: async function (val) {
                const imageUrl = JSON.parse(val).url
                await this.$store.dispatch('profilePicture', imageUrl).then(() => {
                }).catch((error) => {
                    this.doToast(this.$translate('error'), error.message, 'danger')
                })
                console.log(this.model, "profilePicture");
            }
        },
        toggleValue: {
            handler: function (val) {
                console.log("this.toggleValue", val)
                if (val !== null) {
                    this.model.notification = val
                }
            },
        },
    },
    mounted() {
        this.$store.commit('VERIFY_PASSWORD', false)
        this.model = { ...this.$store.state.user }
        this.model.notification = this.toggleValue
    },
    async created() {

    },
    methods: {
        toggleNotification() {
            try {
                const notification = (this.model.notification) ? 1 : 0
                const user_id = this.model.id
                this.$store.dispatch('notifications/toggleNotification', {
                    notification, user_id
                })
                if (notification) {
                    this.doToast(this.$translate('success'), this.$translate('notifications_on'), 'success')
                } else {
                    this.doToast(this.$translate('success'), this.$translate('notifications_off'), 'success')
                }
            } catch (error) {
                console.log("adda", error.response)
                this.doToast(this.$translate('error'), error.response.data.error.message.current_password, 'danger')
            } finally {
                this.updating = false
            }

        },

        cancel() {
            this.$router.push('/customer-portal/service-requests')
        },
        // checkPassword() {
        //     this.$store.dispatch('checkPassword', this.model.current_password)
        // },
        async updatePassword() {
            console.log("CustomerProfile", this.model)
            try {
                this.updating = true
                const userData = this.$store.state.user
                const userId = userData.id
                const is_first_time_login = 0
                const { current_password, password, password_confirmation } =
                    this.model

                if (
                    password != password_confirmation
                ) { throw new Error(this.$translate('password_not_matched')) }
                await this.$store.dispatch('changePassword', {
                    current_password,
                    password,
                    password_confirmation,
                })
                this.model = { ...this.$store.state.user }
                this.doToast(this.$translate('success'), this.$translate('password_updated'), 'success')
                await this.$store.dispatch('users/updateFirstTiemLogin', {
                    userId,
                    is_first_time_login,
                }).then(() => {
                    this.$store.dispatch('logout')
                    if (userData.is_customer_user) {
                        this.$router.push('/customer-login')
                    } else {
                        this.$router.push('/login')
                    }
                })
            } catch (error) {
                this.doToast(this.$translate('error'), error.response ? error.response.data.error.message.password ? error.response.data.error.message.password[0] : error.response.data.error.message.current_password : error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
